<template>
  <div>
    <div class="rounded-19">
      <div :class="'owl-carousel carousel-' + uniqueId + ' rounded-19 w-full cursor-pointer'">
        <div
          v-for="(item, index) in details"
          :key="index"
          class="w-full bg-primary-purple-200 p-2.5 rounded-[19px]"
          :class="item.classes"
        >
          <img :src="item.logo" class="w-full h-full rounded-19" />
        </div>
      </div>
      <div :key="forceRender" class="flex flex-row justify-center gap-8">
        <div
          class="custom-prev cursor-pointer w-4.5 h-4.5 rounded-full flex border-primary-purple-200 hover:border-primary-purple-400 hover:bg-primary-purple-400 border-2 justify-center items-center"
          @click="prevSlide"
        ></div>
        <div
          class="custom-next cursor-pointer hover:border-primary-purple-400 hover:bg-primary-purple-400 w-4.5 h-4.5 border-2 flex border-primary-purple-200 justify-center items-center rounded-full"
          @click="nextSlide"
        ></div>
      </div>
    </div>
    <!-- dummy dot -->
    <div class="mx-auto flex justify-center items-center relative">
      <div
        class="dummy-dot absolute cursor-pointer w-4.5 h-4.5 rounded-full border-primary-purple-400 bg-primary-purple-400 border-2 mb-5"
      ></div>
    </div>
  </div>
</template>

<script>
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'owl.carousel'
export default {
  props: {
    details: { type: Array, default: () => [] },
  },
  data() {
    return {
      uniqueId: Math.random().toString(36).substring(7), // Unique ID for each carousel
      forceRender: 1,
    }
  },

  watch: {
    details: {
      handler() {
        this.$nextTick(() => {
          this.initOwlCarousel()
        })
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.details.length) {
      this.initOwlCarousel()
    }
  },
  beforeUnmount() {
    this.destroyOwlCarousel()
  },
  methods: {
    initOwlCarousel() {
      const options = {
        items: 1,
        autoplay: true,
        loop: true,
        margin: 10,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        nav: false,
        dots: true,
        dotClass: 'custom-dot',
        dotsClass: 'custom-dots',
      }

      // Initialize the carousel scoped to this instance
      $(this.$el.querySelector(`.carousel-${this.uniqueId}`)).owlCarousel(options)
    },
    prevSlide() {
      $(this.$el.querySelector(`.carousel-${this.uniqueId}`)).trigger('prev.owl.carousel')
    },
    nextSlide() {
      $(this.$el.querySelector(`.carousel-${this.uniqueId}`)).trigger('next.owl.carousel')
    },
    destroyOwlCarousel() {
      $(this.$el.querySelector(`.carousel-${this.uniqueId}`))
        .trigger('destroy.owl.carousel')
        .removeClass('owl-loaded')
    },
  },
}
</script>

<style scoped>
.owl-carousel .owl-nav {
  display: none !important;
}
.owl-carousel .custom-dots {
  display: none !important;
}
.carousel-height {
  height: 480px;
}
@media (max-width: 1439px) {
  .carousel-height {
    height: 400px;
  }
}
@media (max-width: 768px) {
  .carousel-height {
    height: 300px;
  }
}

.feature-carousel-height {
  height: 441px;
}
@media (max-width: 1439px) {
  .feature-carousel-height {
    height: 400px;
  }
}
@media (max-width: 767px) {
  .feature-carousel-height {
    height: 300px;
  }
}
</style>